export default __webpack_public_path__ + "static/media/key-feature-responsive.ba750d9b.mp4";